import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../BasketPxDetailsStyled';

export const BasketPxDetailsOV = styled(BasketPxDetailsStyled)`
    .summary {
        .leftSection,
        .rightSection {
            .summaryTitle,
            .summaryValue {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
            }

            .summaryDescription {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            }
        }
    }
`;
